import { brandedValues } from "../Theme/defaultThemeValues";
import {
  DraftClientSetup,
  EDataSyncLevel,
  EDataSyncRefreshRate,
  EDataSyncScope,
  EProductEnums,
  IAppStoreInfo,
  IDataChangedState,
  ILocalState,
  LayoutEnums,
} from "../../@types/index.d";

import {
  Country,
  CustomerState,
  CustomerType,
  ERevenueCurves,
  SelectClientState,
} from "@canei/app-components";
import { EAppStoreMenuItem } from "../../containers/QAppStore";

const initialEventSync: IDataChangedState = {
  timeStamp: -1,
  pending: false,
  timeout: false,
  refreshRate: EDataSyncRefreshRate.IDLE,
};
const data: ILocalState = {
  //__typename: TypeNameEnums.INITIAL_DATA,
  currentUser: {
    //__typename: TypeNameEnums.CURRENT_USER,
    authenticating: false,
    username: "",
    email: "",
    temporaryPassword: "",
    newSusaUploaded: false,
    authenticated: false,
    forceChange: false,
    errors: [],
    attributes: {
      //__typename: TypeNameEnums.USER_ATTRIBUTES,
      customer_id: "",
      user_id: "",
      name: "",
      sub: "",
    },
    clients: [],
    state: CustomerState.UNKNOWN,
    appUser: {
      //__typename: TypeNameEnums.APP_USER,
      user_id: "",
      customer_id: "",
      alias: "",
      email: "",
      root: false,
      links: [],
      clients: [],
      customer: {
        //__typename: TypeNameEnums.CUSTOMER,
        name: "",
        customer_id: "",
        ou: "",
        links: [],
        contact: {
          first_name: "",
          last_name: "",
          telephone: "",
        },
        address: {
          line_1: null,
          line_2: null,
          postal: null,
          telephone: null,
          city: null,
          country: Country.DEU,
        },
        api_access: false,
        type: CustomerType.direct,
      },
    },
    selectedClient: {
      client_id: null,
      state: SelectClientState.UNKNOWN,
      kpis: [],
    },
  },
  appStore: {
    subscriptions: undefined,
    paymentType: undefined,
    features: undefined,
    pricings: undefined,
    customerData: undefined,
    couponList: undefined,
    featuresData: undefined,
    promotionsData: undefined,
    billingAddress: undefined,
    content: undefined,
    selectedMenuItem: "overview" as EAppStoreMenuItem,
    paymentWall: undefined,
    menuSubFeatures: undefined,
    comparisonData: undefined,
  } as IAppStoreInfo,
  draftClient: {
    //__typename: TypeNameEnums.DRAFT_CLIENT,
    customer_id: "",
    client_id: null,
    name: "",
    fiscal_year: "",
    category: "",
    category_type: "",
    // mapping: "",
    errors: [],
    state: DraftClientSetup.DATA,
    address: {
      line_1: "",
      line_2: "",
      city: "",
      postal: "",
      telephone: "",
      country: Country.DEU,
    },
    customization: {
      report_color: "#003f71",
      dashboard_kpis: [],
      // logo: "",
      plan_settings: {
        revenue_curve: ERevenueCurves.OF007,
        revenue_growth: 0,
        revenue_ratios: {
          jan: 8.33,
          feb: 8.33,
          mar: 8.34,
          apr: 8.33,
          may: 8.33,
          jun: 8.34,
          jul: 8.33,
          aug: 8.33,
          sep: 8.34,
          oct: 8.33,
          nov: 8.33,
          dec: 8.34,
        },
      },
    },
  },
  errorState: {
    //__typename: TypeNameEnums.AUTH_ERROR,
    errors: [],
  },
  themeOptions: {
    //__typename: TypeNameEnums.THEME_OPTIONS,
    layout: LayoutEnums.SIMPLE,
    branded: {
      //__typename: TypeNameEnums.THEME_OPTIONS_BRANDED,
      logo: {
        ...brandedValues.logo,
      },
      assets: {
        ...brandedValues.assets,
      },
      buttons: {
        ...brandedValues.buttons,
      },
      inputs: {
        ...brandedValues.inputs,
      },
    },
    sideNavExpanded: true,
  },
  dataSync: {
    [EDataSyncLevel.CLIENT]: {
      [EDataSyncScope.CUSTOMER]: initialEventSync,
      [EDataSyncScope.CLIENT]: initialEventSync,
      [EDataSyncScope.SUSA]: initialEventSync,
      [EDataSyncScope.ERROR]: initialEventSync,
      [EDataSyncScope.EVAL]: initialEventSync,
      [EDataSyncScope.FILE]: initialEventSync,
      [EDataSyncScope.KPI]: initialEventSync,
      [EDataSyncScope.LOGO]: initialEventSync,
      [EDataSyncScope.PLAN]: initialEventSync,
      [EDataSyncScope.SUBSCRIPTION]: initialEventSync,
      [EDataSyncScope.WALLET]: initialEventSync,
      [EDataSyncScope.ALERT]: initialEventSync,
      [EDataSyncScope.PAGE]: initialEventSync,
    },
    [EDataSyncLevel.CUSTOMER]: {
      [EDataSyncScope.CUSTOMER]: initialEventSync,
      [EDataSyncScope.CLIENT]: initialEventSync,
      [EDataSyncScope.SUSA]: initialEventSync,
      [EDataSyncScope.ERROR]: initialEventSync,
      [EDataSyncScope.EVAL]: initialEventSync,
      [EDataSyncScope.FILE]: initialEventSync,
      [EDataSyncScope.KPI]: initialEventSync,
      [EDataSyncScope.LOGO]: initialEventSync,
      [EDataSyncScope.PLAN]: initialEventSync,
      [EDataSyncScope.SUBSCRIPTION]: initialEventSync,
      [EDataSyncScope.WALLET]: initialEventSync,
      [EDataSyncScope.ALERT]: initialEventSync,
      [EDataSyncScope.PAGE]: initialEventSync,
    },
  },
  warmUp: {
    SUSA_TOPIC: {
      client: -1,
      customer: -1,
      error: -1,
      logo: -1,
      file: -1,
      susa: -1,
      user: -1,
      kpi: -1,
      eval: -1,
    },
    FILE_TOPIC: {
      client: -1,
      customer: -1,
      error: -1,
      logo: -1,
      file: -1,
      susa: -1,
      user: -1,
      kpi: -1,
      eval: -1,
    },
  },
  downloads: [],
  uploads: [],
  systemMessages: [],
  renderRules: {
    dashboardComponents: {
      overview: false,
      overview_cards: false,
      success: false,
      kpis: false,
      assets: false,
      offer: false,
      abnormalities: false,
      bankers: false,
      liquidity: false,
      profitloss: false,
      grade: false,
      costs: false,
      upgrade: false,
    },
    dashboardGrid: [],
    menuItems: {
      overview: false,
      kpis: false,
      success: false,
      assets: false,
      profitloss: false,
      liquidity: false,
      abnormalities: false,
      bankers: false,
      grade: false,
      costs: false,
      upgrade: false,
      canei_pro: false,
      offer: false,
    },
    reports: {
      RP004: false, // Monatsbericht
      RP005: false, // Monatszeugnis
      RP008: false, // Potentialübersicht
      RP009: false, // Risikoanalyze
      RP010: false, // Bankersperspectiv
      RP011: false, // Liquiditätsbericht
      RP013: false, // ESG Bericht
      RP014: false, // Ertragsbericht
    },
    userMenuItems: {
      company: false,
      feature_store: false,
      susa_list: false,
      user: false,
      invoices: false,
      logout: false,
    },
    logo: "" as EProductEnums,
  },
};
const initialData = {
  ...data,
};
export default initialData;
